export class AddressCheckNotice {
    constructor(closed, error, address) {
        this.type = "addressCheck";
        this.error = error;
        this.closed = closed;
        this.address = address;
    }
    static getType() {
        return "addressCheck";
    }
}
export class AddressCheckAddress {
}
